/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IButtonStyles } from '@fluentui/react/lib/Button';
import { IStackStyles } from '@fluentui/react/lib/Stack';
import { IStyle, ITheme } from '@fluentui/react/lib/Styling';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { getHTMLDir } from '../../../utilities/Utils';

export const getLabelStyles = (theme: ITheme, isCurrent: boolean): Partial<IStackStyles> => {
    const isRtl = getHTMLDir(getAppHost().getLocaleName()) === 'rtl';
    let styles: IStyle = {
        height: '20px',
        width: '20px',
        background: theme.palette.neutralLight,
        borderRadius: '50%',
        marginLeft: isRtl ? '0.75rem' : 0,
        marginRight: isRtl ? 0 : '0.75em',
        paddingBottom: '1px',
    };

    if (isCurrent) {
        styles = Object.assign(styles, { background: theme.palette.themePrimary, color: theme.palette.white });
    }

    return { root: styles };
};

export const getStackStyles = (theme: ITheme, isCurrent: boolean, isDisabled: boolean): Partial<IStackStyles> => {
    return {
        root: {
            width: '100%',
            fontWeight: isCurrent ? 'bold' : 'normal',
            cursor: 'default',
            color: isDisabled ? theme.palette.neutralSecondary : theme.palette.black,
            padding: '0.375rem 1rem',
            selectors: {
                '&:hover': {
                    background: !isDisabled && theme.palette.neutralLight,
                },
            },
        },
    };
};

export const getButtonStyles = (theme: ITheme): Partial<IButtonStyles> => {
    return {
        flexContainer: { justifyContent: 'flex-start' },
        root: {
            border: 'none !important',
            background: 'transparent',
            padding: '0',
            boxShadow: 'none',
            selectors: {
                '&:focus,&:active': {
                    background: 'transparent !important',
                },
                '&:focus::after': {
                    borderColor: `${theme.palette.black} !important`,
                },
            },
        },
    };
};
